import axiosInstance from '../../config/axiosConfig';
import { urlProbabilidad } from '../../config/apiURL';
import { extractArray, extractDataObject } from '../utils/responseHelpers';

// Obtener todas las probabilidades
export async function getProbabilidad(emp_codigo) {
  try {
    const response = await axiosInstance.get(`${urlProbabilidad}/empresa/${emp_codigo}`);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching probabilidad:', error);
    throw error;
  }
}

export async function getProbabilidadPorId(id) {
  try {
    const response = await axiosInstance.get(`${urlProbabilidad}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error fetching probabilidad ${id}:`, error);
    throw error;
  }
}

export async function updateProbabilidad(id, formulario) {
  try {
    const response = await axiosInstance.put(`${urlProbabilidad}/${id}`, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error updating probabilidad ${id}:`, error);
    throw error;
  }
}

export async function createProbabilidad(formulario) {
  try {
    const response = await axiosInstance.post(urlProbabilidad, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating probabilidad:', error);
    throw error;
  }
}

export async function deleteProbabilidad(id) {
  try {
    const response = await axiosInstance.delete(`${urlProbabilidad}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting probabilidad ${id}:`, error);
    throw error;
  }
}